<template>
  <form @submit.prevent="">
    <dt-modal v-model="isVisible" :modalSize="modalSize">
      <div slot="header" class="custom-header">
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-md-1">
            <a href="#" @click="close" class="custom-close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div slot="body" class="profileWrapper" data-testid="user-profile-dialog">
        <user-profile
          ref="userProfile"
          :cameFrom="value !== null ? value.cameFrom : 0"
          :isAdd="value !== null ? value.isAdd : false"
          @saved="userSaved"
          @changed="userChanged"
        />
      </div>
      <div class="custom-footer" slot="footer">
        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="sendChangePassword"
            v-if="value !== null ? !value.isAdd : true"
          >
            Change Password
          </button>
        </div>
        <div class="col-md-7">
          <span title="firm id / user id / contact id">{{ ids }}</span>
        </div>
        <div class="col-md-2 custom-right-align">
          <button type="button" class="btn btn-light" @click="close()" data-testid="cancel-button">Cancel</button>
          <button
            v-show="isSaved"
            class="btn btn-primary"
            :class="{ 'btn-danger': isSave }"
            @click="submit"
          >
            Save
          </button>
        </div>
      </div>
    </dt-modal>
  </form>
</template>
<script>
import { mapGetters } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import UserProfile from '@/components/users/forms/user-profile.vue'
export default {
  name: 'user-profile-dialog',
  components: {
    DtModal,
    UserProfile
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: 'modal-xl',
      isSave: false
    }
  },
  mounted() {
    let $this = this
    setTimeout(() => {
      $this.isSave = false
    }, 350)
  },
  computed: {
    ...mapGetters('users', ['user']),
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isSaved: {
      get() {
        let _is = false
        if (this.value !== undefined && this.value !== null) {
          if (!this.value.isAdd) {
            _is = true
          }
        }
        return _is
      },
      set(value) {
        this.$emit('send', {
          isUpdate: true,
          user: this.user.user,
          contact: this.user.contact,
          fullName: `${this.user.lastName}, ${this.user.firstName}`
        })
      }
    },
    title() {
      let _title = ''
      if (this.value !== undefined && this.value !== null) {
        if (this.value.isAdd) {
          if (this.value.data.name === '') {
            _title = 'Adding User'
          } else {
            _title = `Adding User to ${this.value.data.name}`
          }
        } else {
          if (this.value.firstName !== undefined) {
            _title = `User Profile for ${this.value.firstName} ${this.value.lastName}`
          } else {
            _title = `Editing User: ${this.value.data.fullName}`
          }
        }
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.value !== undefined && this.value !== null) {
        if (this.value.isAdd) {
          _ids = ''
        } else {
          if (this.value.firstName !== undefined) {
            _ids = `${this.value.firm}/${this.value.user}/${this.value.contact}`
          } else {
            _ids = `${this.value.data.firm}/${this.value.data.user}/${this.value.data.contact}`
          }
        }
      }
      return _ids
    }
  },
  methods: {
    sendChangePassword() {
      let data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        user: this.user.user,
        contact: this.user.contact,
        username: this.user.username
      }
      this.$emit('sendChangePassword', data)
    },
    close() {
      this.isSave = false
      this.$emit('closing')
    },
    userChanged() {
      this.isSave = true
    },
    userSaved(saved) {
      this.isSave = false
      this.isSaved = saved
      this.$emit('saved', saved)
    },
    async submit() {
      await this.$refs.userProfile.save()
      this.$emit('send', {
        isUpdate: false,
        user: null,
        contact: null,
        username: null,
        firstName: null,
        lastName: null
      })
      this.isSave = false
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-textarea {
  height: 200px;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.profileWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-profile-dialog.vue